import { AppDialog } from '@/components/app/app-dialog';
import { Button } from '@/components/ui/button.tsx';
import { NlToBr } from '@/components/app/nl-to-br.tsx';
import { setConfirmInfo, useUiStore } from '@/stores/ui.store.ts';

export function GlobalConfirm() {
  const confirmInfo = useUiStore((state) => state.confirmInfo);
  if (!confirmInfo || !confirmInfo.message || !confirmInfo.onConfirm) {
    return null;
  }
  const onCancel = () => {
    setConfirmInfo(null);
  };
  const onConfirm = async () => {
    let res: void | boolean = true;
    if (typeof confirmInfo.onConfirm === 'function') {
      res = await confirmInfo.onConfirm(confirmInfo.payload);
    }
    if (res !== false) {
      setConfirmInfo(null);
    }
  };
  return (
    <AppDialog title={confirmInfo.title || 'Confirm'} onClose={onCancel}>
      <div className="p-3">
        {typeof confirmInfo.message === 'string' ? (
          <NlToBr lines={confirmInfo.message} />
        ) : (
          confirmInfo.message
        )}
        <div className="flex justify-end gap-2 mt-3">
          <Button onClick={onCancel} className="btn btn-secondary">
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            className="btn btn-primary"
          >
            Confirm
          </Button>
        </div>
      </div>
    </AppDialog>
  );
}
